import React from 'react';
import { arrayOf, string } from 'prop-types';
import { isExternalLink } from '../../utils/url';

function EventCard({
  Url: url,
  Thumbnail: thumbnail,
  ThumbnailAltText: altText,
  Name: name,
  Date: date,
  TopicTags: tags,
  externalLinkText
}) {
  const isExternal = isExternalLink(url);
  return (
    <a href={url}
      className={`article-event-result-card hover-card ${isExternal ? 'faculty-staff-listing__external-card' : ''}`}
      target={isExternal ? '_blank' : null}
      rel={isExternal ? 'noopener noreferrer' : null}
    >
      {isExternal && <span className="visually-hidden">{externalLinkText}</span>}
      {thumbnail && (
        <div className="article-event-result-card__thumbnail-container">
          <img
            src={thumbnail}
            alt={altText}
            className="article-event-result-card__thumbnail"
            data-object-fit="cover"
          />
        </div>
      )}
      <div className="article-event-result-card__description">
        <h3 className="article-event-result-card__heading">{name}</h3>
        <p className="article-event-result-card__date">{date}</p>
        <ul className="article-event-result-card__tags">
          {tags.map((tag) => (
            <li key={tag} className="article-event-result-card__tag">
              {tag}
            </li>
          ))}
        </ul>
      </div>
    </a>
  );
}

EventCard.propTypes = {
  Url: string.isRequired,
  Thumbnail: string.isRequired,
  ThumbnailAltText: string.isRequired,
  Name: string.isRequired,
  Date: string.isRequired,
  TopicTags: arrayOf(string.isRequired).isRequired,
  externalLinkText: string.isRequired
};

export default React.memo(EventCard);
